const engTranslations = {
  translations: {
    header: {
      disclaimer: 'Disclaimer',
      about: 'About',
      login: 'Login',
      logoImage: 'LogoImage',
    },
    footer: {
      copyright: '© 2021 MARK STEPHENSON, UNIVERSITY OF WISCONSIN-MADISON, ALL RIGHTS RESERVED.',
    },
    selectionData: {
      selectYear: 'Select Year:',
      annualHistoricProduction: 'Annual Historic Production',
      annualHistoricProductionTooltip: 'Starting in 2026, DMC\'s Tier 1 coverage level increases from 5 million pounds to 6 million pounds. All dairy operations that elect to enroll in DMC for 2026 will establish a new production history. Existing dairy operations that began marketing milk on or before January 1, 2023, will use the higher of their milk marketings from 2021, 2022, or 2023. New dairy operations that started after January 1, 2023, will use their first year of monthly milk marketings, even if it is only a partial year. Milk marketing statements or other production evidence are required to establish this production history.',
      coveragePercentage: 'Coverage Percentage:',
      coveredAnnualProduction: 'Covered Annual Production',
      tier1: 'Tier 1',
      tier2: 'Tier 2',
      unit: 'lbs',
      annualPremiumAndFee: 'Annual Premium & Fee',
      averagePremiumPerCwt: 'Average Premium per cwt',
      coveredProductionHistory: 'Covered Production History (lbs):',
      t1CoverageLevel: 'Tier 1 Coverage Level:',
      t2CoverageLevel: 'Tier 2 Coverage Level:',
      coverageLevel: 'Coverage Level',
      choice: 'Choice ($/cwt)',
      coveredProdHistory: 'Covered Prod History (lbs)',
      totalPremium: 'Total Premium ($/cwt)',
    },
    coverageSelectionAndAnalysisPage: {
      title: 'Dairy Margin Coverage Decision Tool',
      calculator: {
        selectionTitle: 'Coverage Selection',
        tiers: {
          tier1: 'Tier 1',
          tier2: 'Tier 2',
        },
        table: {
          coverageLevel: 'Coverage Level',
          choice: 'Choice',
          premium: 'Premium',
          na: 'na',
        },
      },
    },
    navigation: {
      selectionAndAnalysis: 'Coverage Selection',
      forecastMargin: 'Forecast Margin',
      futureAndPrices: 'Forecast Future and Government Prices',
      alerts: 'Alerts',
      netBenefitEstimator: 'Net Benefit Forecasts',
      historicPerformance: 'Historic Performance',
      milikPricePaymentTriggerAnalysis: 'Milk Price Payment Trigger Analysis',
      priceForecasts: 'Price Forecasts',
    },
    historicAnalysis: {
      title: 'Historic Performance',
      startYear: 'Start Year*',
      endYear: 'End Year',
      numOfMonths: 'Total number of months',
      numOfMonthsWithPayout: 'Number of months with payout',
      averageDMCPremiumPerCwt: 'Average DMC premium per cwt',
      averagePaymentPerCwt: 'Average payment per cwt',
      maxPaymentPerCwt: 'Max payment per cwt',
      averageNetIndemnityPerCwt: 'Average net indemnity per cwt',
      cumulativeNetIndemnity: 'Cumulative net indemnity',
      info: '*Start years prior to the beginning of the DMC program in 2019 are estimates',
      tierThresholdInfo: 'The Tier 1 annual threshold of 6 million pounds is applied across all historical years',
      DMCNetBenefit: 'DMC Net Benefit',
      DMCNetBenefitInfo: 'Indemnity payments minus premiums',
    },
    milkPriceAnalysis: {
      title: 'DMC Milk Price Payment Trigger Analysis',
      forecastYear: 'Forecast Year',
      info: '*Feed Cost were estimated based on futures market values as of {{currentDate}}',
      localBasis: 'Local Basis',
      month: 'Month',
      forecastFeedCost: 'Forecast Feed Cost',
      coverageLevel: 'Coverage Level',
      milkPriceTrigger: 'Milk Price Trigger',
    },
    netBenefitEstimator: {
      title: 'Net Benefit Estimator',
      subtitles: {
        DMCNetBenefitEstimator: 'Dairy Margin Net Benefit Estimator',
        priceAndMarginForecast: 'Price and Margin Forecast',
      },
      forecastDateInfo: '*Projected prices and margins are updated each business day, until the day when USDA announces the actual prices and margins. Typically, final DMC margins are announced about 30 days after the end of month. Current estimate date: {{currentDate}}',
      finalMarginInfo: 'Bold indicates USDA FSA final margin has been released.',
      tableHeaders: {
        month: 'Month',
        forcastedMargin: 'Actual / Forecasted Margin',
        t1ProdHistory: 'Tier 1 Covered production history (lbs)',
        t2ProdHistory: 'Tier 2 Covered production history (lbs)',
        t1CoveredPayment: 'Tier 1 Forecasted Payment Per Cwt',
        t2CoveredPayment: 'Tier 2 Forecasted Payment per Cwt',
        totalPayment: 'Total Payment',
        milkForecast: 'All Milk Price forecast ($/cwt)',
        cornForecast: 'Corn Price forecast ($/bu)',
        alfalfaHayForecast: 'premium/supreme alfalfa hay price forecast ($/ton)',
        soybeanForecast: 'SOYBEAN MEAL PRICE FORECAST ($/TON)',
        feedCostForecast: 'Feed cost forecast ($/cwt)',
        DMCMarginForecast: 'DMC Margin forecast ($/cwt)',
      },
    },
  },
};

export default engTranslations;
